import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation, useQueryClient } from 'react-query';
import { rejectFlexMatchRequest } from 'RestAPIs/flex-match';

export type RejectFlexMatchRequestPayload = {
  body: {
    requestId: number;
    processInstanceId: string;
  };
};

const useRejectFlexMatchRequest = ({ isWebSocketUpdate = false }) => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: RejectFlexMatchRequestPayload) => rejectFlexMatchRequest(payload),
    {
      onSuccess: () => {
        !isWebSocketUpdate && queryClient.invalidateQueries(['flexMatchTasks']);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useRejectFlexMatchRequest;
